import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  // mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const metaauth = to.matched.find(record => record.meta.requiresAuth);
  // console.log(to);
  // console.log(metaauth);

  if (to.path === "/logout") {
    // console.log("logout");
    store.dispatch("logout");
    next({
      path: "/login"
    });
    return;
  }
  if (metaauth) {
    let user = store.state.user; // LoadUser();
    // console.log(user);
    if (user === null) {
      // console.log("user is null");
      next({
        name: "Login",
        params: { nextUrl: to.fullPath }
      });
    } else {
      if (to.matched.some(record => record.meta.requiresRole)) {
        // console.log("user requiresRole");
        if (user.roleid > 0 && user.roleid <= 3) {
          if (user.roleid === 3 && to.path.indexOf("/student/") === -1) {
            next({
              path: "/notfound",
              params: { nextUrl: to.fullPath }
            });
            return;
          }
          next();
        } else {
          next({
            path: "/login",
            params: { nextUrl: to.fullPath }
          });
        }
      } else {
        // console.log("no  requiresRole");
        // console.log(to);
        next();
        // next();
      }
    }
  } else next();
});

export default router;
